import React from 'react'
import { ExternalLink } from 'src/components/Core/Styles/Link'

export const textLink = <ExternalLink href='https://www.sucdenfinancial.com/en/client-documentation-and-disclosures/.'>www.sucdenfinancial.com/en/client-documentation-and-disclosures/</ExternalLink>
